/* eslint-disable */
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from '../../shared/services/modal.service';

@Component({
  selector: 'md-actionHelper',
  template: require('./actionHelper.component.html')
})

export class ActionHelperComponent {
  @Input() options;

  constructor(router: Router, modal: ModalService) {
    this.router = router;
    this.modal = modal;
  }

  actionHelperClicked(action, event) {
    switch (action) {
      case 'editPersonalInfo':
        this.modal.editInfo({
          modalType: 'editPersonalInfo',
          fukTopRight: false,
          formData: this.options,
          title: this.options.editTitle,
          modalClass: this.options.modalClass,
          content: this.options.body,
          buttons: this.options.buttons,
        });
        break;

      case 'editAddressInfo':
        this.modal.editInfo({
          modalType: 'editAddressInfo',
          fukTopRight: false,
          formData: this.options,
          title: this.options.editTitle,
          modalClass: this.options.modalClass,
          content: this.options.body,
          buttons: this.options.buttons,
        });
    }
  }
}
